/* eslint-disable no-console */
/* eslint-disable react/no-children-prop */
import {
  makeStyles,
  RACModalCard,
  Typography,
  RACButton,
  Grid,
} from '@rentacenter/racstrap';
import React from 'react';
import { ReactComponent as ApiSuccessIcon } from '../../assets/img/TickIcon.svg';
import { ReactComponent as ApiErrorIcon } from '../../assets/img/apiErrorIcon.svg';
import { ReactComponent as NoRecordsFound } from '../../assets/img/No-records.svg';

export interface ModalProps {
  open: boolean;
  message?: string;
  secondmsg?: string;
  error?: boolean;
  onClose: () => void;
  isNoRecordsFound?: boolean;
}

export const useStyles = makeStyles((theme: any) => ({
  dialogContent: {
    textAlign: 'center',
    marginLeft: theme.typography.pxToRem(8),
    marginRight: theme.typography.pxToRem(8),
  },
  dialogRoot: {
    '& .MuiDialogContent-root': {
      padding: '1rem',
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  justifyContentCenter: {
    justifyContent: 'center',
  },
  spacerMT4: {
    marginTop: theme.typography.pxToRem(24),
  },
  spacerMR2: {
    marginRight: theme.typography.pxToRem(8),
  },
  textCenter: {
    textAlign: 'center',
  },
  RACPOPMsg: {
    marginTop: theme.typography.pxToRem(12),
    fontFamily: 'OpenSans-regular',
    fontSize: '1rem !important',
    letterSpacing: 0,
  },
}));

export const ApiSuccessModal: React.FC<ModalProps> = ({
  open,
  message,
  secondmsg,
  error,
  onClose,
  isNoRecordsFound,
}) => {
  const classes = useStyles();
  const RecordCheckModalContent = () => {
    return (
      <>
        {isNoRecordsFound ? (
          <NoRecordsFound />
        ) : error === true ? (
          <ApiErrorIcon />
        ) : (
          <ApiSuccessIcon />
        )}
        <Grid item md={12}>
          <Grid item md={12} className={classes.textCenter}>
            <Typography
              variant="h6"
              className={classes.RACPOPMsg}
              style={{ fontWeight: 'bold' }}
            >
              {message}
            </Typography>
            <Typography
              variant="body2"
              className={`${classes.RACPOPMsg} ${classes.dialogContent}`}
            >
              {secondmsg}
            </Typography>
          </Grid>
          <Grid
            container
            className={`${classes.justifyContentCenter} ${classes.spacerMT4}`}
          >
            <RACButton
              size="small"
              variant="contained"
              color="primary"
              onClick={onClose}
            >
              ok
            </RACButton>
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <RACModalCard
      isOpen={open}
      classes={{
        dialog: classes.dialogRoot,
      }}
      maxWidth="sm"
      children={RecordCheckModalContent()}
      closeIcon={true}
      onClose={onClose}
      borderRadius="20px"
    />
  );
};
